import {
  AbstractControl,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
  ValidationErrors,
} from '@angular/forms';
import { getDuplicateValuesFromArray } from '../../../../../common/utils';
import { isEqual } from 'lodash';
import { PartnerType } from '../constants';

export const rowsValidator = (
  index: number,
  partnerTypeControl: UntypedFormControl | AbstractControl,
): ValidationErrors | null => {
  return (formGroup: UntypedFormGroup) => {
    if (formGroup.parent) {
      const array = formGroup.parent as UntypedFormArray;

      if (partnerTypeControl.value === PartnerType.Customer) {
        customerPartnerType(array);
      } else {
        notCustomerPartnerType(array);
      }
    }
  };
};

function customerPartnerType(array: UntypedFormArray): void {
  const uniqueFormGroupList: UntypedFormGroup[] = [];
  const duplicatedFormGroupList: UntypedFormGroup[] = [];

  [...array.controls].forEach((formG: UntypedFormGroup) => {
    if (!uniqueFormGroupList.length) {
      uniqueFormGroupList.push(formG);
    } else {
      const duplicatedFormGroup: UntypedFormGroup = uniqueFormGroupList.find((formGroup: UntypedFormGroup) =>
        isEqual(formG.value, formGroup.value),
      );

      duplicatedFormGroup ? duplicatedFormGroupList.push(formG, duplicatedFormGroup) : uniqueFormGroupList.push(formG);
    }
  });

  uniqueFormGroupList.forEach((formGroupRemoveError: UntypedFormGroup) => {
    for (const key in formGroupRemoveError.controls) {
      if (!formGroupRemoveError.controls[key].value) {
        formGroupRemoveError.controls[key].setErrors({ required: true });
      } else {
        formGroupRemoveError.controls[key].setErrors(null);
      }
    }
  });

  if (duplicatedFormGroupList.length) {
    duplicatedFormGroupList.forEach((formG: UntypedFormGroup) => {
      Object.values(formG.controls).forEach((c: UntypedFormControl) => c.setErrors({ duplicated: true }));
    });
  }
}

function notCustomerPartnerType(array: UntypedFormArray): void {
  const typeControls = array.controls.map((group: UntypedFormGroup) => group.get('type'));
  const typeControlValues = typeControls.map((c: UntypedFormControl) => c.value);
  const duplicateValues = getDuplicateValuesFromArray<PartnerType>(typeControlValues);

  if (duplicateValues.length) {
    const errorControls = typeControls.filter((control: UntypedFormControl) => duplicateValues.includes(control.value));

    errorControls.forEach((control: UntypedFormControl) => {
      control.setErrors({ duplicated: true });
    });
  } else {
    typeControls.forEach((control: UntypedFormControl) => {
      if (!control.value) {
        control.setErrors({ required: true });
      } else {
        control.setErrors(null);
      }
    });
  }
}
